var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartDoughnut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M10.892 17.417V23C5.51 22.463 1.266 18.03 1 12.548h5.517a5.522 5.522 0 004.375 4.869zM23 12c0 5.732-4.344 10.446-9.907 11v-5.583c2.513-.512 4.404-2.743 4.404-5.417s-1.891-4.905-4.404-5.417V1C18.656 1.554 23 6.268 23 12zM3.718 4.71l3.916 3.916a5.538 5.538 0 00-.894 1.72H1.11A11.028 11.028 0 013.72 4.71zM10.892 1v5.583a5.469 5.469 0 00-1.592.596L5.326 3.204A10.927 10.927 0 0110.892 1z"
  }))));
}

export default SvgChartDoughnut;